module.exports = __webpack_public_path__ + "static/img/projectcovermobile.7747083.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/costumers/Pods/projectcovermobile.png
// module id = J2tm
// module chunks = 0